// @ts-nocheck
import React from "react";
import { Loading } from "qjumpers.common.ui";
// import PropTypes from "prop-types";

const Loader = () => {
  return <Loading className="loading-component" />;
};

export default Loader;
